export default {
  root: {
    '& h2': {
      display: 'none'
    }
  }

};
